module.exports = __webpack_public_path__ + "static/media/article3.bcf7b9b1.webp";